// Commerce Ace — About Timeline Accordion

(function () {

  document.querySelectorAll('.ca-about-timeline__item').forEach(function (item) {
    const toggle = /** @type {HTMLElement | null} */ (item.querySelector('.ca-about-timeline__toggle'));
    const details = /** @type {HTMLElement | null} */ (item.querySelector('.ca-about-timeline__details'));

    if (!toggle || !details) return;

    toggle.addEventListener('click', function () {
      const isOpen = item.classList.contains('ca-about-timeline__item--open');

      if (isOpen) {
        item.classList.remove('ca-about-timeline__item--open');
        details.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = '+';
      } else {
        item.classList.add('ca-about-timeline__item--open');
        details.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = '−';
      }
    });
  });

})();